import { sendObject } from './handler';

export type Override = { type: 'override'; id: string };

export const postOverride = async (id: string): Promise<void> =>
  sendObject({ type: 'override', id });
